import { Option, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { int32ToString, equals } from "../fable_modules/fable-library-js.4.19.0/Util.js";
import { CustomColors_bfsOrange } from "../../Bfs.Web.Portale/Helpers.fs.js";
import { Size_ISize, Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { map, toArray, isEmpty, singleton, ofArray } from "../fable_modules/fable-library-js.4.19.0/List.js";
import { Record } from "../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, bool_type } from "../fable_modules/fable-library-js.4.19.0/Reflection.js";
import * as react from "react";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value as value_1 } from "../fable_modules/fable-library-js.4.19.0/Option.js";
import { NotificationContext__get_FilteredNotifications, NotificationContext__get_UnreadCount, NotificationFilter, currentNotificationContext } from "../Context.fs.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.19.0/Seq.js";
import { spinner } from "../../Bfs.Web.Portale/ViewParts.fs.js";

function toggleButton(currentValue, value, label, onChange) {
    return button(ofArray([new Option(0, [equals(currentValue, value) ? CustomColors_bfsOrange : (new Color_IColor(3, []))]), new Option(1, [new Size_ISize(0, [])]), new Option(18, [(_arg) => {
        onChange(value);
    }]), new Option(19, ["is-rounded"])]), singleton(label));
}

function attachClickListener(f) {
    document.addEventListener("click", f);
    return {
        Dispose() {
            document.removeEventListener("click", f);
        },
    };
}

export class ListProps extends Record {
    constructor(IsDropdown) {
        super();
        this.IsDropdown = IsDropdown;
    }
}

export function ListProps_$reflection() {
    return record_type("Bfs.Web.Kundenportal.Notifications.List.ListProps", [], ListProps, () => [["IsDropdown", bool_type]]);
}

function noNotificationsView(filter) {
    const text = (filter.tag === 1) ? "Keine ungelesenen Benachrichtigungen" : "Keine Benachrichtigungen";
    const children_4 = [react.createElement("div", {
        className: "icon",
    }), react.createElement("div", {}, text)];
    return react.createElement("div", {
        className: "notification-list-empty",
    }, ...children_4);
}

function oneNotificationView(navigate, notification) {
    let children_4;
    let key;
    const matchValue = notification.BenachrichtigungsTyp;
    key = ((matchValue.tag === 1) ? matchValue.fields[0] : ((matchValue.tag === 2) ? matchValue.fields[0].TicketAntwortId : matchValue.fields[0]));
    const isNew = notification.IstNeu ? "is-new" : "";
    const children_6 = [(children_4 = [react.createElement("h3", {
        className: "is-size-6 has-text-weight-medium",
    }, notification.Titel), react.createElement("span", {}, notification.Beschreibung)], react.createElement("div", {
        className: `notification-list-item ${isNew}`,
    }, ...children_4))];
    return react.createElement("a", {
        key: key,
        onClick: (_arg) => {
            navigate(notification.BenachrichtigungsTyp);
        },
    }, ...children_6);
}

export const View = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_1("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\Notifications\\List.fs") + "#L") + int32ToString(value_1(67))) + ";") + "Bfs.Web.Kundenportal.Notifications.List.ListProps", value_1("View"), (props) => {
    let children_22, children_18, children_4, children_2, children_16, children_20;
    const containerClass = props.IsDropdown ? "dropdown-menu" : "";
    const contentClass = props.IsDropdown ? "dropdown-content" : "";
    const notificationContext = react.useContext(currentNotificationContext);
    const containerRef = react.useRef(undefined);
    if (props.IsDropdown) {
        react.useEffect(() => {
        const disp = (() => attachClickListener((event) => {
            if ((((containerRef.current != null) && (window.innerWidth > 1024)) && !value_1(containerRef.current).contains(event.target)) && notificationContext.ShowNotifications) {
                notificationContext.ToggleShowNotifications();
            }
        }))();
        return () => disp.Dispose();
    }, [notificationContext.ShowNotifications]);
    }
    const children_24 = [(children_22 = [(children_18 = [(children_4 = [react.createElement("h2", {
        className: "is-size-5",
    }, "Benachrichtigungen"), (children_2 = [toggleButton(notificationContext.Filter, new NotificationFilter(0, []), "Alle", notificationContext.ChangeFilter), toggleButton(notificationContext.Filter, new NotificationFilter(1, []), "Ungelesen", notificationContext.ChangeFilter)], react.createElement("div", {
        className: "block",
    }, ...children_2))], react.createElement("div", {
        className: "notification-header-row",
    }, ...children_4)), (children_16 = toList(delay(() => {
        let children_8, children_12;
        return append((NotificationContext__get_UnreadCount(notificationContext) === 0) ? singleton_1((children_8 = [react.createElement("div", {
            className: "read-icon",
        }), "keine neuen Benachrichtigungen"], react.createElement("div", {
            className: "unread-count",
        }, ...children_8))) : singleton_1((children_12 = [react.createElement("div", {
            className: "count-icon",
        }), `${NotificationContext__get_UnreadCount(notificationContext)} ungelesene`], react.createElement("div", {
            className: "unread-count",
        }, ...children_12))), delay(() => ((NotificationContext__get_UnreadCount(notificationContext) > 0) ? singleton_1(react.createElement("a", {
            onClick: (_arg) => {
                notificationContext.MarkAllRead();
            },
        }, "Alle als gelesen markieren")) : empty())));
    })), react.createElement("div", {
        className: "notification-header-row",
    }, ...children_16))], react.createElement("div", {
        className: "notification-header",
    }, ...children_18)), (children_20 = toList(delay(() => {
        const matchValue_3 = NotificationContext__get_FilteredNotifications(notificationContext);
        return notificationContext.NotificationsLoading ? singleton_1(spinner) : (isEmpty(matchValue_3) ? singleton_1(noNotificationsView(notificationContext.Filter)) : singleton_1(toArray(map((notification) => oneNotificationView(notificationContext.Navigate, notification), matchValue_3))));
    })), react.createElement("div", {
        className: "notification-list",
    }, ...children_20))], react.createElement("div", {
        className: `${contentClass} notifications`,
    }, ...children_22))];
    return react.createElement("div", {
        className: containerClass,
        ref: containerRef,
    }, ...children_24);
}, undefined, undefined, "Of");

//# sourceMappingURL=List.fs.js.map
